import { render, staticRenderFns } from "./ProductPriorityStrategy.vue?vue&type=template&id=56bc1804"
import script from "./ProductPriorityStrategy.vue?vue&type=script&lang=js"
export * from "./ProductPriorityStrategy.vue?vue&type=script&lang=js"
import style0 from "./ProductPriorityStrategy.vue?vue&type=style&index=0&id=56bc1804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports